import { buildMultipartRequest } from "@am/multi_step_forms/buildMultipartRequest";

export function buildSubmitRequest(
	values,
	filesState,
	csrfToken,
	submitUrl,
	recaptchaToken,
) {
	return buildMultipartRequest(submitUrl, csrfToken, values, (req) => {
		if (recaptchaToken) req.field("g-recaptcha-response", recaptchaToken);
		(filesState.photos || []).forEach((item, index) => {
			req.attach("photos", item.file, item.file.name);
			req.field(`copyright_${index}`, item.copyrightText || "");
			req.field(`photographer_${index}`, item.photographer || "");
		});
	});
}
